export enum TopicType {
    Firmware = 1,
    Menu = 2,
    Config = 3,
};